<template>
    <div id="simulator">
        <header-signature :text="messages.title" />
        <div v-if="!selectedVariationLabel" class="d-md-none pb-1">
            <!-- affichage du bloc d'incitation en mode mobile-->
            <div class="lead">
                <strong v-html="incentiveMessageMobile" />
            </div>
        </div>
        <div class="simulator-block-border">
            <div class="row px-1">
                <div class="col-12 col-md-6 px-0 pb-1 simulator-block-separator">
                    <ob1-message-alerte
                        :title="messages.subtitle"
                        type="info"
                        :is-simple-alerte="true"
                    />
                    <div class="px-1 ps-md-1 pe-md-2">
                        <ob1-select-field
                            id="variation-selector"
                            v-model="selectedVariationLabel"
                            :elements="variationLabels"
                            :place-holder="messages.select"
                            @input="onInput"
                        />
                    </div>
                </div>
                <div v-if="!selectedVariationLabel" class="col-md-6 d-none d-md-block pt-2 ps-2 pe-1">
                    <!-- affichage du bloc d'incitation en mode tablette et desktop-->
                    <div class="lead">
                        <strong v-html="messages.incentive" />
                    </div>
                    <div class="font-size-28 text-primary">
                        <span class="alert-icon icon-goto-gauche" aria-hidden="true" />
                    </div>
                </div>
                <div v-else class="col-md-6 px-md-2 pt-md-2 pb-md-1">
                    <hr class="separator d-md-none mb-1 separator--gray4">
                    <variation-detail
                        :next-url="selectedVariation.nextUrl"
                        :label="optionLabel"
                        :banner-label="selectedVariation.banner"
                        :price-block="selectedVariation.priceBlockDTO"
                        :button-label="selectedVariation.buttonLabel"
                        :attributes="selectedVariation.attributes"
                        button-track-zone="ajouter_cette_assurance"
                        button-track-nom="assurance_selectionnee"
                        :button-track-cible="selectedVarationTrackCible"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VariationDetail from "./VariationDetail.vue";
import HeaderSignature from "../../common/components/vue/HeaderSignature.vue";
import {toTmsFormat} from "./TmsUtils";

export default {
    components: {HeaderSignature, VariationDetail},
    props: {
        variations: {
            type: Array,
            required: true
        },
        preSelectedVariationId: {
            type: String,
            required: false,
            default: null
        },
        messages: {
            type: Object,
            required: true
        },
        optionLabel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            selectedVariationLabel: this.getVariationLabel(this.preSelectedVariationId)
        }
    },
    computed: {
        incentiveMessageMobile() {
            return this.messages.incentive.replace(/<br>/g, " ");
        },
        selectedVariation() {
            return this.variations.find((variation) => variation.label === this.selectedVariationLabel)
        },
        variationLabels() {
            return this.variations.map((elt) => elt.label);
        },
        selectedVarationTrackCible() {
            return toTmsFormat(this.selectedVariation.label)
        }
    },
    methods: {
        onInput() {
            this.$emit('input', this.selectedVariation.variationId);
        },
        getVariationLabel: function (variationId) {
            let variation = this.variations.find((elt) => elt.variationId === variationId);
            if (variation) {
                return variation.label;
            } else {
                return null;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'ob1_variables';

.simulator-block-border {
    border: 0.0625rem solid $gray-light;
}

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .simulator-block-separator {
        border-top: none;
        border-bottom: none;
        border-right: 0.0625rem solid $gray-light;
    }
}

</style>
